import { Countries } from '../constants/Countries.js';

export const CountryListInput = Countries.map((c) => ({
  label: c.name,
  value: c.alpha2Code
})).sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));

export const CountryListInputNoZA = CountryListInput.filter((c) => c.value !== 'ZA');
